import React from "react";
import FAQSection from "./faqs";
import Footer from "../home/footer";

const FaqsMain = () => {
  return (
    <>
      <FAQSection />

      <Footer />
    </>
  );
};

export default FaqsMain;
